// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Link from "../Link.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Colors from "common/src/Colors.bs.js";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as StatsTooltip from "./StatsTooltip.bs.js";
import * as UnitImageExtended from "common/src/tft-static/UnitImageExtended.bs.js";

function UnitInfoRect(Props) {
  var stats = Props.stats;
  var totalEntries = Props.totalEntries;
  var unitId = Props.unitId;
  var onUnitSelected = Props.onUnitSelected;
  var set = TftSet.use(undefined);
  var unitsT = Translation.useT(/* Units */1);
  var language = Translation.useLocale();
  ApertureCtx.useValue(undefined);
  var aperture = ApertureCtx.useValue(undefined);
  var filteredItems = [];
  Belt_Array.forEach(stats.topItems, (function (itemId) {
          if (filteredItems.length >= 3) {
            return ;
          }
          var info = Data.itemInfo(itemId, set);
          if (info !== undefined && Belt_Array.some(Caml_option.valFromOption(info).tags, (function (tag) {
                    return [
                              "Craftable",
                              "CraftableEmblem"
                            ].includes(tag);
                  }))) {
            filteredItems.push(itemId);
            return ;
          }
          
        }));
  var items = Belt_Array.slice(filteredItems, 0, 3);
  var v = stats.starPlace;
  return React.createElement(Link.make, {
              prefetch: false,
              onClick: (function (param) {
                  return Curry._1(onUnitSelected, unitId);
                }),
              route: {
                TAG: /* Stats */0,
                _0: {
                  TAG: /* Unit */4,
                  unit: unitId,
                  starLevel: undefined,
                  aperture: aperture
                }
              },
              children: React.createElement("div", {
                    className: CssJs.merge([
                          "flex cursor-pointer relative",
                          CssJs.style([
                                CssJs.background(Colors.tierDesaturatedColorAlpha2(Sd.unitTier(unitId), 0.17)),
                                CssJs.border(CssJs.px(2), CssJs.solid, Colors.tierDesaturatedColorAlpha2(Sd.unitTier(unitId), 0.35))
                              ])
                        ])
                  }, React.createElement("div", {
                        className: CssJs.merge([
                              "absolute top-[-10px] right-0 flex pr-[2px]",
                              CssJs.style([
                                    CssJs.borderTopRightRadius(CssJs.px(8)),
                                    CssJs.alignSelf(CssJs.flexStart)
                                  ])
                            ])
                      }, Belt_Array.map(Sd.getUnitTraits(unitId, set), (function (traitId) {
                              return React.createElement(TraitImage.make, {
                                          traitId: traitId,
                                          size: 18,
                                          sizeLg: 20,
                                          key: traitId
                                        });
                            }))), React.createElement(UnitTooltip.make, {
                        unit: unitId,
                        children: React.createElement("div", {
                              className: "flex flex-col flex-shrink-0 justify-between relative h-[60px]"
                            }, React.createElement(UnitImage.make, {
                                  unitId: unitId,
                                  size: 60,
                                  borderSize: 0,
                                  showName: false
                                }), React.createElement("div", {
                                  className: "absolute right-0 flex justify-center left-[-1px] bottom-[-7px]"
                                }, React.createElement(UnitImageExtended.Items.make, {
                                      unfiltered: true,
                                      items: items
                                    })))
                      }), React.createElement(Tooltip.make, {
                        title: React.createElement("div", {
                              className: "flex flex-col"
                            }, React.createElement(StatsTooltip.make, {
                                  stats: [
                                    [
                                      "Play rate",
                                      (Global.f(stats.count) / Global.f(totalEntries) * 8).toFixed(2) + "/8"
                                    ],
                                    [
                                      "Place",
                                      stats.place.toFixed(2)
                                    ],
                                    [
                                      "Top4",
                                      Global.formatPct3(stats.top4)
                                    ],
                                    [
                                      "Win",
                                      Global.formatPct3(stats.won)
                                    ],
                                    [
                                      "3* Rate",
                                      Global.formatPct(undefined, Global.f(stats.starCount) / Global.f(stats.count)) + "%"
                                    ],
                                    [
                                      "3* Place",
                                      (v == null) ? "-" : Global.toFixed(undefined, v)
                                    ]
                                  ]
                                })),
                        children: React.createElement("div", {
                              className: "flex flex-col overflow-hidden h-[56px] p-2 py-[7px] lg:h-[60px] lg:pl-[10px] lg:pr-[3px]"
                            }, React.createElement("div", {
                                  className: CssJs.merge([
                                        "text-base font-medium whitespace-no-wrap truncate",
                                        CssJs.style([
                                              CssJs.fontSize(language === "ja" ? CssJs.px(15) : CssJs.px(17)),
                                              CssJs.color(CssJs.rgba(255, 255, 255, {
                                                        NAME: "num",
                                                        VAL: 0.87
                                                      })),
                                              CssJs.marginLeft(CssJs.px(-1)),
                                              CssJs.marginTop(CssJs.px(3)),
                                              CssJs.marginBottom(CssJs.px(4))
                                            ])
                                      ])
                                }, unitsT(unitId)), React.createElement("div", {
                                  className: "text-sm leading-none"
                                }, React.createElement("div", {
                                      className: "flex"
                                    }, React.createElement("div", {
                                          className: "w-[34px]"
                                        }, Global.toFixed(undefined, Global.f(stats.count) / Global.f(totalEntries) * 8)), React.createElement("div", {
                                          className: CssJs.merge([
                                                "text-right w-[34px]",
                                                CssJs.style([CssJs.borderLeft(CssJs.px(1), CssJs.solid, CssJs.rgba(255, 255, 255, {
                                                                NAME: "num",
                                                                VAL: 0.6
                                                              }))])
                                              ])
                                        }, Global.toFixed(undefined, stats.place)))))
                      }))
            });
}

var make = UnitInfoRect;

export {
  make ,
  
}
/* Sd Not a pure module */
